import React, { useState, useEffect, useRef } from "react";
import { Tag, Button, Input, Card, message, Skeleton, Select, Modal, Col, Drawer, Spin } from "antd";
import {
  PhoneOutlined,
  EnvironmentOutlined,
  StarFilled,
  EditOutlined,
  CloseOutlined,
  CloseSquareFilled,
  CustomerServiceOutlined,
  ArrowLeftOutlined,
  ClockCircleOutlined,
  SearchOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import CustomerSearch from "../../../assets/images/search.png";
import CustomerIcon from "../../../assets/images/userId.svg";
import View from "../../../assets/images/view.svg";
import AddUser from "../../../assets/images/userAdd.svg";
import DefaultProductImage from "../../../assets/images/no-image.svg";
import DeleteProduct from "../../../assets/images/delete1.svg";
import BackIcon from "../../../assets/images/backIcon.svg";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import POSLogo from "../../../assets/images/NewLogoCW.svg";
import LockIcon from "../../../assets/images/lock-icon.svg";
import userIcon from "../../../assets/images/userId.svg";
import Online from "../../../assets/images/green.svg";
import Offline from "../../../assets/images/red.svg";
import cardType from "../../../assets/images/cardType.svg";
import UPI from "../../../assets/images/upiIcon.svg";
import dayjs from "dayjs";
import Scrollbars from "react-custom-scrollbars";
import { v4 as uuidv4 } from "uuid";
import { posOrderProcessor1 } from "../../../services";
import { getRetailStores } from "../../../services/generic";
import db from "../../../database";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useCartStore from "../../../stores/useCartStore";
import useAuthStore from "../../../stores/useAuthStore";
import useSessionStore from "../../../stores/useSessionStore";

import useCallCenterTimer from "./useCallCenterTimer";
import useHoldQueue from "./useHoldQueue";
import useCallCenterCustomer from "./useCallCenterCustomer";
import { CallCenterLandingPanel, StoreSelectionDrawer } from "./CallCenterPanel";

const RestaurantCallCenter = (props) => {
  const {
    tillData,
    selectCustomer,
    setDisplayCustomerSearch,
    setCloseCustomerFlag,
    setProductSearchInput,
    closeCustomerSearch,
    showEditOldCustomerFields,
    showAddNewCustomerFields,
    removeCutomer,
    setEditFlag,
    customerId,
    setCustomerSearchResults,
    setCustomerSearchInput,
    handleCustomerSearch,
    setKeyboardInputFields,
    keyboardInputFields,
    inputName,
    keyboard,
    setLoading,
    productSearchInput,
    setProductsData,
    saleTypeProducts,
    setSaleTypeProducts,
    productsData,
    handleAddOnModal,
    restaurantProductCategory,
    pickProduct,
    deleteProduct,
    callCenterVisible,
    setCallCenterVisible,
    callCenterModal,
    setCallCenterModal,
    increaseProductQty,
    decreaseProductQty,
    setCart,
    setIsCallCenterFlow,
    isCallCenterFlow,
    showCallCenterPage,
    setShowCallCenterPage,
    holdQueue,
    setHoldQueue,
    searchOrderHistory,
    setShowProducts,
    orderHistoryDetails,
    setOrderHistoryDetails,
    loading,
    showPayments,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    processOrder,
    getFilteredPaymentMethods,
  } = props;
  const [selectedAddress, setSelectedAddress] = useState("Home");
  const [selectedMode, setSelectedMode] = useState("Delivery");
  const [showPriceDetails, setShowPriceDetails] = useState(false);
  const defaultCustomer = tillData.tillAccess.csBunit.b2cCustomer;
  const [showCallCenter, setShowCallCenter] = useState(false);
  const tillDocumentSequence = useSessionStore.getState().documentSequence;
  const userData = useAuthStore.getState().userData;
  const tillValue = useAuthStore.getState().tillValue;
  const [isPaymentSelected, setIsPaymentSelected] = useState(false);
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const showImage = posConfig?.showImage === "Y";
  const pricePrecision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision;
  const orderState = useRef(0);
  const activeOrderProcess = useRef(false);
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const history = useHistory();
  const modes = ["Delivery", "Pickup", "Dine-in"];
  const cart = useCartStore.getState().cart;

  // --- Extracted hooks ---
  const { ahtSeconds, setAhtSeconds, timerRef, formatAHT } = useCallCenterTimer({
    callCenterVisible,
  });

  const {
    productsList,
    filteredProducts,
    setFilteredProducts,
    productCategoriesList,
    selectCategoryList,
    setSelectCategoryList,
    displayedProducts,
    hasMoreProducts,
    retailStores,
    setRetailStores,
    selectedStore,
    setSelectedStore,
    storeModalVisible,
    setStoreModalVisible,
    scrollContainerRef,
    handleCategoryClick,
  } = useCallCenterCustomer({
    tillData,
    callCenterVisible,
    cart,
    setCart,
    setLoading,
    searchOrderHistory,
  });

  const { resumeHoldCall, putCallOnHold } = useHoldQueue({
    holdQueue,
    setHoldQueue,
    setCart,
    clearCartData,
    setCallCenterVisible,
    setOrderHistoryDetails,
    setIsPaymentSelected,
    setSelectedStore,
    setAhtSeconds,
    timerRef,
    formatAHT,
  });

  const onChangeInput = (event) => {
    const inputVal = event.target.value;
    setKeyboardInputFields({
      ...keyboardInputFields,
      [inputName]: inputVal,
    });
    keyboard?.current?.setInput(inputVal);
  };

  const clearCartData = {
    items: [],
    couponInput: [],
    advancePayment: 0,
    total: 0,
    tax: 0,
    discount: 0,
    paid: 0,
    change: 0,
    totalQty: 0,
    roundOff: 0,
    payments: [],
    redemptionPoints: 0,
    accumulationPoints: 0,
    creditAmount: 0,
    docType: "Invoice",
    sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
    referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
    giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    customer: defaultCustomer,
    salesRepId: null,
    cardPaymentData: {},
    documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
    userName: userData?.user,
    tillName: tillValue?.name,
    subTotal: 0,
    itemsSummery: {},
    amountInWords: "",
    groupedItemsByTaxRate: {},
  };

  const getPriorityTag = (priority) => {
    if (priority === "HIGH") return <Tag color="red">HIGH</Tag>;
    if (priority === "MEDIUM") return <Tag color="gold">MEDIUM</Tag>;
    return <Tag color="green">LOW</Tag>;
  };

  // Random pastel colors for product cards
  const pastelColors = ["#F8C8DC", "#FFD1D1", "#FFE5B4", "#FFF4C1", "#D4F4DD", "#C8E6F5", "#D1E8FF", "#E6E6FA", "#F0D4F0", "#FFE4E1", "#E0F7FA", "#F5F5DC"];

  const getColorFromId = (id) => {
    const hash = id.split("").reduce((a, b) => a + b.charCodeAt(0), 0);
    return pastelColors[hash % pastelColors.length];
  };

  const handleCardPayment = async () => {
    try {
      const total = parseFloat(cart?.total || 0);
      if (total <= 0) {
        message.error("Cart is empty");
        return;
      }

      if (!selectedPaymentMethod) {
        message.error("Select a payment method");
        return;
      }

      const newLine = {
        name: selectedPaymentMethod.name,
        amount: total.toFixed(pricePrecision || 2),
      };

      const updatedCart = {
        ...cart,
        payments: [...(cart.payments || []), newLine],
        paid: total,
        change: 0,
      };

      setCart(updatedCart);

      if (tillData?.tillAccess?.posConfig?.transactionID === "Y" && selectedPaymentMethod.name === "Card") {
        return;
      }

      await posOrderProcessor1(updatedCart);
      message.success("Order placed!");

      setCart(clearCartData);
      setSelectedPaymentMethod(null);
      setCallCenterVisible(false);
      setIsPaymentSelected(false);
    } catch (err) {
      console.error(err);
      message.error("Failed to place order");
    }
  };

  const handlePlaceOrder = async () => {
    if (!selectedPaymentMethod) {
      message.error("Please select a payment method");
      return;
    }
    const total = parseFloat(cart?.total || 0);
    if (total <= 0) {
      message.error("Cart is empty");
      return;
    }

    const paymentLine = {
      name: selectedPaymentMethod.name,
      amount: total.toFixed(pricePrecision || 2),
    };

    const updatedCart = {
      ...cart,
      payments: [...(cart.payments || []), paymentLine],
      paid: total,
      change: 0,
    };

    setCart(updatedCart);

    if (tillData?.tillAccess?.posConfig?.transactionID === "Y" && selectedPaymentMethod.name === "Card") {
      message.info("Enter card details then submit");
      return;
    }

    orderState.current = 0;
    try {
      await processOrder("normal");
    } catch (err) {
      console.error(err);
      message.error("Failed to place order");
    }
  };

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} spin />} spinning={loading}>
      <div style={{ fontFamily: "Inter", maxHeight: "100vh", paddingBottom: "70px", backgroundColor: "white" }}>
        {/* Top Header Bar (100% width) */}
        {callCenterVisible ? (
          <>
            <div
              style={{
                backgroundColor: "#fff",
                border: "1px solid #e0e0e0",
                padding: "10px 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                marginBottom: "0",
                position: "relative",
              }}
            >
              {/* Back Icon */}
              <img
                src={BackIcon}
                alt="Back"
                style={{
                  height: "24px",
                  cursor: "pointer",
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
                onClick={() => {
                  history.push("/pos");
                }}
              />

              {/* LEFT SECTION */}
              <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap", marginLeft: "36px" }}>
                <Tag color="blue" style={{ borderRadius: "15px" }}>
                  Caller
                </Tag>

                <span style={{ fontWeight: 600, color: "#0F0718" }}>
                  <PhoneOutlined style={{ marginRight: 6 }} />
                  {cart?.customer?.mobileNo ? `+91 ${cart.customer.mobileNo}` : "+91 –"}
                </span>

                <span style={{ fontWeight: 600, color: "#0F0718" }}>{cart?.customer?.name || "Guest"}</span>

                <span style={{ color: "#929098" }}>{cart?.customer?.customerAddress?.city || cart?.customer?.customerAddress?.region || "–"}</span>

                <Tag color="blue" style={{ borderRadius: "15px" }}>
                  Status: Available
                </Tag>
              </div>

              {/* RIGHT SECTION */}
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Tag color="blue" style={{ borderRadius: "20px" }}>
                  AHT {formatAHT(ahtSeconds)}
                </Tag>
                <Button
                  style={{ borderRadius: "10px", color: "#2f3856" }}
                  onClick={() => {
                    putCallOnHold({ cart, selectedStore, ahtSeconds });
                  }}
                >
                  Hold
                </Button>
                <Button
                  type="primary"
                  danger
                  style={{ borderRadius: "10px" }}
                  onClick={() => {
                    setCallCenterVisible(false);
                    setCart(clearCartData);
                    setIsPaymentSelected(false);
                  }}
                >
                  End Call
                </Button>
              </div>
            </div>

            {/* Content Area (below header) */}
            <div style={{ display: "flex", height: "calc(100vh - 60px)" }}>
              {/* LEFT PANEL - Customer Search (20%) */}
              <div
                style={{
                  width: "20%",
                  backgroundColor: "#fff",
                  borderRight: "1px solid #e0e0e0",
                  padding: "15px",
                  overflowY: "auto",
                  height: "100%",
                }}
              >
                {/* Search Customer */}
                <div style={{ marginBottom: "15px" }}>
                  <p style={{ fontSize: "11px", fontWeight: 600, color: "#777", marginBottom: "6px" }}>SEARCH CUSTOMER</p>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId ? (
                      <Input
                        className="productSearch-sm"
                        id="sm-customer-search"
                        style={{
                          borderRadius: "0.5vw",
                          height: "4.9vh",
                          borderColor: "#fff",
                        }}
                        placeholder="Enter customer number/name"
                        prefix={<img src={CustomerSearch} alt="" style={{ height: "2.7vh" }} />}
                        onClick={() => {
                          if (cart?.isReturn !== true) {
                            setDisplayCustomerSearch(true);
                            setCloseCustomerFlag(true);
                            setProductSearchInput("");
                          }
                        }}
                        onChange={(e) => {
                          if (navigator.onLine) {
                            onChangeInput(e);
                            if (e.target.value === "") {
                              setCustomerSearchResults();
                              setCustomerSearchInput(e.target.value);
                              setLoading(false);
                            } else {
                              setCustomerSearchInput(e.target.value);
                              setLoading(true);
                              handleCustomerSearch(e.target.value)
                                .then((results) => {
                                  setCustomerSearchResults(results);
                                  setLoading(false);
                                })
                                .catch(() => {
                                  setLoading(false);
                                });
                            }
                          } else {
                            setLoading(false);
                          }
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          padding: "0.7vh 1.3vh",
                          border: "none",
                          background: "#fff",
                          borderRadius: "4px",
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          height: "5vh",
                          alignItems: "center",
                        }}
                      >
                        <span>
                          <img src={CustomerIcon} style={{ height: "3.5vh" }} alt="" />{" "}
                          <span style={{ fontSize: "1vw" }}>
                            {cart?.customer?.name} - {cart?.customer?.b2cCustomerSegment?.name}
                          </span>
                        </span>
                        <span>
                          <img
                            src={View}
                            style={{
                              height: "3vh",
                              paddingBottom: "0.1em",
                              cursor: "pointer",
                            }}
                            id="sm-customer-view"
                            onClick={() => {
                              if (cart.isReturn !== true) showEditOldCustomerFields(cart?.customer);
                            }}
                          />{" "}
                          &#124;{" "}
                          <EditOutlined
                            style={{ cursor: "pointer" }}
                            id="sm-customer-edit"
                            onClick={() => {
                              if (cart.isReturn !== true) {
                                showEditOldCustomerFields(cart?.customer);
                                setEditFlag(true);
                              }
                            }}
                          />{" "}
                          &#124;{" "}
                          <CloseOutlined
                            style={{ fontSize: "2vh", cursor: "pointer" }}
                            onClick={() => {
                              if (cart.isReturn !== true) removeCutomer();
                            }}
                          />
                        </span>
                      </div>
                    )}

                    <img
                      src={AddUser}
                      style={{
                        height: "1.6vw",
                        paddingLeft: "1vw",
                        cursor: "pointer",
                        display: cart?.customer?.cwrCustomerId === customerId ? "" : "none",
                      }}
                      onClick={() => {
                        if (cart.isReturn !== true) {
                          showAddNewCustomerFields(cart.customer);
                          setProductSearchInput("");
                        }
                      }}
                    />
                  </div>
                </div>

                {/* Customer Info */}
                <div
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "10px",
                    padding: "10px 12px",
                    marginBottom: "15px",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontWeight: 600, color: "#2F3856" }}>{cart?.customer?.name || "Guest"}</span>
                    <Tag
                      color="gold"
                      style={{
                        borderRadius: "12px",
                        fontWeight: 600,
                        fontSize: "12px",
                        padding: "0 6px",
                      }}
                    >
                      <StarFilled style={{ color: "#f5a623", marginRight: 3 }} />
                      {cart?.customer?.loyaltyPoints ?? 420}
                    </Tag>
                  </div>
                  <p style={{ fontSize: "13px", color: "#333", marginTop: "4px" }}>{cart?.customer?.mobileNo ? `+91 ${cart.customer.mobileNo}` : "+91 –"}</p>
                </div>

                {/* Delivery Addresses */}
                <div style={{ marginBottom: "15px" }}>
                  <p style={{ fontSize: "11px", fontWeight: 600, color: "#777", marginBottom: "8px" }}>DELIVERY ADDRESSES</p>
                  <div
                    onClick={() => setSelectedAddress("Home")}
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      padding: "2px 5px",
                      marginBottom: "8px",
                      backgroundColor: selectedAddress === "Home" ? "#f0f6ff" : "#fff",
                      cursor: "pointer",
                    }}
                  >
                    <p style={{ fontSize: "11px", fontWeight: 500, color: "#929098", marginBottom: 4 }}>Home</p>
                    <p style={{ fontSize: "11px", fontWeight: 500, marginBottom: 1, color: "#0F0718" }}>
                      {cart?.customer?.customerAddress?.city || cart?.customer?.customerAddress?.region || "–"}
                    </p>
                    <p style={{ fontSize: "11px", color: "#0F0718", marginBottom: 1 }}>
                      {cart?.customer?.customerAddress?.line1
                        ? `${cart.customer.customerAddress.line1}${cart.customer.customerAddress.line2 ? `, ${cart.customer.customerAddress.line2}` : ""}`.trim()
                        : ""}
                    </p>
                    {cart?.customer?.pincode && <p style={{ fontSize: "10px", color: "#929098", marginBottom: 1 }}>Pin: {cart.customer.pincode}</p>}
                  </div>
                </div>

                {/* ORDER HISTORY */}
                <div style={{ marginTop: "15px" }}>
                  <p style={{ fontSize: "11px", fontWeight: 600, color: "#777", marginBottom: "5px" }}>ORDER HISTORY</p>
                  {loading ? (
                    <Skeleton active paragraph={{ rows: 2 }} />
                  ) : !orderHistoryDetails || orderHistoryDetails.length === 0 ? (
                    <p style={{ textAlign: "center", color: "#999", margin: "12px 0" }}>No previous orders</p>
                  ) : (
                    <Scrollbars style={{ height: "220px" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "10px", paddingRight: "4px" }}>
                        {orderHistoryDetails.map((order) => (
                          <div
                            key={order.sOrderID}
                            style={{
                              border: "1px solid #e0e0e0",
                              borderRadius: "10px",
                              padding: "10px 12px",
                              backgroundColor: "#fff",
                            }}
                          >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "4px" }}>
                              <div>
                                <div style={{ fontWeight: 600, fontSize: "13px", color: "#0F0718" }}>{order.documentno}</div>
                                <div style={{ fontSize: "11px", color: "#666" }}>{dayjs(order.dateordered).format("YYYY-MM-DD")}</div>
                              </div>
                              <Tag color="#dcfce7" style={{ color: "#166534", borderRadius: "12px", fontSize: "10px", fontWeight: 500, padding: "0 6px", border: "none" }}>
                                Delivered
                              </Tag>
                            </div>
                            <div style={{ fontWeight: 600, fontSize: "13px", color: "#0F0718" }}>
                              {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                              {order.total}
                              {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                            </div>
                          </div>
                        ))}
                      </div>
                    </Scrollbars>
                  )}
                </div>
              </div>

              {/* MIDDLE PANEL - Products (57%) */}
              <div
                style={{
                  width: "57%",
                  backgroundColor: "#fff",
                  borderRight: "1px solid #e0e0e0",
                  padding: "10px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "500",
                }}
              >
                {/* Search Bar */}
                <div style={{ marginBottom: "10px" }}>
                  <Input
                    placeholder="Search for products by code/name"
                    value={productSearchInput}
                    onChange={(e) => {
                      const searchTerm = e.target.value.toLowerCase();
                      setProductSearchInput(searchTerm);
                      if (searchTerm === "") {
                        const sortedCategories = [...productCategoriesList].sort((a, b) => a.name.localeCompare(b.name));
                        if (sortedCategories.length > 0) {
                          const firstCategoryId = sortedCategories[0].mProductCategoryId;
                          setSelectCategoryList([firstCategoryId]);
                          setFilteredProducts(productsList.filter((product) => product.mProductCategoryId === firstCategoryId));
                        } else {
                          setFilteredProducts(productsList);
                          setSelectCategoryList([]);
                        }
                      } else {
                        const matchingProducts = productsList.filter((p) => p.name.toLowerCase().includes(searchTerm));
                        setFilteredProducts(matchingProducts);
                        if (matchingProducts.length > 0) {
                          setSelectCategoryList([matchingProducts[0].mProductCategoryId]);
                        } else {
                          setSelectCategoryList([]);
                        }
                      }
                    }}
                    style={{ color: "#929098", borderRadius: "8px", height: "30px", width: "100%" }}
                    prefix={<img src={SearchIcon} alt="Search" style={{ width: 16, height: 16, opacity: 0.6, marginRight: 0 }} />}
                    suffix={
                      productSearchInput?.length > 0 ? (
                        <CloseSquareFilled
                          onClick={() => {
                            setProductSearchInput("");
                            const sortedCategories = [...productCategoriesList].sort((a, b) => a.name.localeCompare(b.name));
                            if (sortedCategories.length > 0) {
                              const firstCategoryId = sortedCategories[0].mProductCategoryId;
                              setSelectCategoryList([firstCategoryId]);
                              setFilteredProducts(productsList.filter((product) => product.mProductCategoryId === firstCategoryId));
                            } else {
                              setFilteredProducts(productsList);
                              setSelectCategoryList([]);
                            }
                          }}
                          style={{ color: "#999", cursor: "pointer", fontSize: 18 }}
                        />
                      ) : null
                    }
                    onPressEnter={() => {
                      const searchTerm = productSearchInput.toLowerCase();
                      const matchingProducts = productsList.filter((p) => p.name.toLowerCase().includes(searchTerm));
                      setFilteredProducts(matchingProducts);
                      if (matchingProducts.length > 0) {
                        setSelectCategoryList([matchingProducts[0].mProductCategoryId]);
                      }
                    }}
                  />
                </div>

                {/* Categories */}
                <div style={{ display: "flex", overflowX: "auto", color: "#0F0718", fontWeight: "500", gap: "8px", paddingBottom: "10px", marginBottom: "10px" }}>
                  {productCategoriesList
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((cat) => (
                      <button
                        key={cat.mProductCategoryId}
                        onClick={() => handleCategoryClick(cat.mProductCategoryId)}
                        style={{
                          backgroundColor: selectCategoryList.includes(cat.mProductCategoryId) ? "#eff6ff" : "#fff",
                          color: selectCategoryList.includes(cat.mProductCategoryId) ? "#2563eb" : "#0F0718",
                          fontWeight: 500,
                          border: "1px solid #e0e0e0",
                          borderRadius: "14px",
                          padding: "6px 12px",
                          fontSize: "13px",
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {cat.name}
                      </button>
                    ))}
                </div>

                {/* Scrollable Product Grid */}
                <div style={{ flex: 1, overflowY: "auto", paddingRight: "4px", position: "relative" }} ref={scrollContainerRef}>
                  {displayedProducts.length === 0 ? (
                    <p style={{ textAlign: "center", color: "#999", marginTop: "20px" }}>No products found</p>
                  ) : (
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: "12px" }}>
                      {displayedProducts.map((product) => (
                        <Card
                          key={product.mProductId}
                          style={{
                            borderRadius: "10px",
                            border: "1px solid #e8e8e8",
                            padding: "10px",
                            cursor: "pointer",
                            color: "#0F0718",
                            fontWeight: "500",
                            backgroundColor: getColorFromId(product.mProductId),
                            overflow: "hidden",
                            height: showImage ? "130px" : "90px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: showImage ? "flex-start" : "center",
                            position: "relative",
                          }}
                          onClick={() => pickProduct(product)}
                        >
                          {showImage && (
                            <div style={{ height: "60px", marginBottom: "6px", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <img
                                src={product.imageurl || DefaultProductImage}
                                alt={product.name}
                                style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
                                onError={(e) => (e.currentTarget.src = DefaultProductImage)}
                              />
                            </div>
                          )}
                          <p
                            title={product.name}
                            style={{
                              fontWeight: 500,
                              fontSize: "13px",
                              margin: 0,
                              lineHeight: "1.4",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100%",
                              padding: "0 4px",
                            }}
                          >
                            {product.name}
                          </p>
                          <p style={{ color: "green", fontWeight: 500, fontSize: "12px", margin: "4px", position: "absolute", bottom: "8px", right: "10px" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {product.sunitprice.toFixed(2)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </p>
                        </Card>
                      ))}
                    </div>
                  )}
                  {hasMoreProducts && (
                    <div style={{ textAlign: "center", padding: "16px" }}>
                      <Skeleton active paragraph={{ rows: 2 }} />
                    </div>
                  )}
                </div>
              </div>

              {/* RIGHT PANEL - Checkout (23%) */}
              <div
                style={{
                  width: "23%",
                  backgroundColor: "#fff",
                  padding: "10px",
                  overflow: "hidden",
                  height: "100%",
                  borderLeft: "1px solid #e0e0e0",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* FIXED HEADER */}
                <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "8px", marginBottom: "5px" }}>
                  <h3 style={{ margin: 0, color: "#0F0718" }}>Checkout</h3>
                  <Button
                    type="text"
                    size="small"
                    style={{
                      fontSize: "12px",
                      color: "#0F0718",
                      fontWeight: 500,
                      border: "1px solid #d9d9d9",
                      borderRadius: "6px",
                      padding: "2px 8px",
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      maxWidth: "140px",
                      overflow: "hidden",
                      margin: 0,
                    }}
                    onClick={() => setStoreModalVisible(true)}
                  >
                    <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }} title={selectedStore?.name || "Select Store"}>
                      Store: {selectedStore?.name || "Select"}
                    </span>
                  </Button>
                </div>

                {/* Delivery Mode Buttons */}
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "14px", backgroundColor: "#fff", borderRadius: "20px", padding: "3px" }}>
                  {modes.map((mode) => {
                    const isActive = selectedMode === mode;
                    return (
                      <Button
                        key={mode}
                        size="small"
                        onClick={() => setSelectedMode(mode)}
                        style={{
                          flex: 1,
                          margin: "0 2px",
                          borderRadius: "20px",
                          backgroundColor: isActive ? "#3c4866" : "#F5F5F5",
                          color: isActive ? "#fff" : "#333",
                          border: "none",
                          fontWeight: 500,
                        }}
                      >
                        {mode}
                      </Button>
                    );
                  })}
                </div>

                {/* SCROLLABLE MIDDLE: Address, ETA, Cart Items */}
                <div style={{ flex: 1, overflowY: "auto", paddingRight: "4px" }}>
                  {/* Serving Location */}
                  <div style={{ border: "1px solid #e0e0e0", borderRadius: "8px", padding: "2px 5px", marginBottom: "10px" }}>
                    <p style={{ fontSize: "11px", fontWeight: 500, color: "#929098", marginBottom: 4 }}>SERVING LOCATION</p>
                    <p style={{ fontSize: "11px", fontWeight: 500, marginBottom: 1, color: "#0F0718" }}>
                      {cart?.customer?.customerAddress?.city || cart?.customer?.customerAddress?.region || "–"}
                    </p>
                    <p style={{ fontSize: "11px", color: "#0F0718", marginBottom: 1 }}>
                      {cart?.customer?.customerAddress?.line1
                        ? `${cart.customer.customerAddress.line1}${cart.customer.customerAddress.line2 ? `, ${cart.customer.customerAddress.line2}` : ""}`.trim()
                        : ""}
                    </p>
                    {cart?.customer?.pincode && <p style={{ fontSize: "10px", color: "#929098", marginBottom: 1 }}>Pin: {cart.customer.pincode}</p>}
                  </div>

                  {/* Promise Time */}
                  <div
                    style={{
                      border: "1px solid #92909880",
                      color: "#929098",
                      borderRadius: "8px",
                      padding: "4px",
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ fontSize: "12px", color: "#555" }}>Promise Time</span>
                    <Select
                      size="small"
                      defaultValue="30"
                      style={{ width: 70 }}
                      options={[
                        { value: "15", label: "15" },
                        { value: "20", label: "20" },
                        { value: "30", label: "30" },
                        { value: "45", label: "45" },
                      ]}
                    />
                  </div>

                  {/* CART ITEMS */}
                  <div style={{ border: "1px solid #e0e0e0", borderRadius: "8px", padding: "10px", maxHeight: "180px", overflowY: "auto", marginBottom: "12px" }}>
                    <p style={{ fontWeight: 500, fontSize: "13px", marginBottom: "8px", color: "#0F0718" }}>Cart Items ({cart?.items?.length || 0})</p>
                    {cart?.items?.length > 0 ? (
                      cart.items.map((item, idx) => (
                        <div
                          key={item.mProductId || idx}
                          style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #f0f0f0", padding: "8px 0" }}
                        >
                          <div>
                            <p style={{ fontWeight: 500, fontSize: "11px", color: "#0F0718", margin: 0 }}>{item.name}</p>
                            <p style={{ fontSize: "10px", color: "#929098", margin: 0, fontWeight: "500" }}>
                              {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                              {item.nettotal.toFixed(2)}
                              {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                            </p>
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <Button size="small" shape="circle" onClick={() => decreaseProductQty(item)}>
                              -
                            </Button>
                            <span style={{ fontWeight: 500, color: "#0F0718", fontSize: "11px" }}>{item.weight || 1}</span>
                            <Button size="small" shape="circle" onClick={() => increaseProductQty(item)}>
                              +
                            </Button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p style={{ textAlign: "center", color: "#999", marginTop: "20px" }}>No items in cart</p>
                    )}
                  </div>
                </div>

                {/* FIXED FOOTER: Coupon, Price, Buttons */}
                <div style={{ borderTop: "1px solid #e0e0e0", paddingTop: "10px" }}>
                  {/* Coupon Code */}
                  <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "12px" }}>
                    <Input placeholder="Enter coupon code" size="middle" style={{ flex: 1, borderRadius: "7px", height: "30px" }} />
                    <Button type="primary" style={{ backgroundColor: "#7dcf7d", border: "none", borderRadius: "7px", height: "30px" }}>
                      Best
                    </Button>
                  </div>

                  {/* Price Details */}
                  <div style={{ fontSize: "11px", fontWeight: "500", marginBottom: "5px", color: "#0F0718" }}>
                    <div
                      onClick={() => setShowPriceDetails((prev) => !prev)}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        marginBottom: "6px",
                        backgroundColor: "#f3f4f9",
                        padding: "6px 10px",
                        borderRadius: "6px",
                      }}
                    >
                      <span style={{ fontWeight: 600, fontSize: "12px" }}>View Details</span>
                      <span style={{ transform: showPriceDetails ? "rotate(90deg)" : "rotate(0deg)", transition: "transform 0.2s ease", fontSize: "14px" }}>▶</span>
                    </div>

                    {showPriceDetails && (
                      <div style={{ animation: "fadeIn 0.2s ease" }}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <span>Items</span>
                          <span>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {(cart?.subTotal ?? 0).toFixed(2)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <span>Packing</span>
                          <span>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {(cart?.packingCharge ?? 0).toFixed(2)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <span>Delivery</span>
                          <span>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {(cart?.deiveryCharge ?? 0).toFixed(2)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <span>Tax</span>
                          <span>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {(cart?.tax ?? 0).toFixed(2)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", color: "green" }}>
                          <span>Discount</span>
                          <span>
                            {currenciesList[0].symbolRightSide === "Y" ? `-${currenciesList[0].currSymbol} ` : "-"}
                            {(cart?.discount ?? 0).toFixed(2)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </span>
                        </div>
                        <hr style={{ margin: "8px 0" }} />
                      </div>
                    )}

                    <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 600, marginTop: showPriceDetails ? "0" : "8px" }}>
                      <span>Total Payable</span>
                      <span>
                        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                        {(cart?.total ?? 0).toFixed(2)}
                        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                      </span>
                    </div>
                  </div>

                  {/* Payment Methods */}
                  <div style={{ marginBottom: "10px", fontWeight: "500" }}>
                    <p style={{ fontSize: "12px", fontWeight: 500, color: "#929098", marginBottom: 6 }}>PAYMENT METHOD</p>
                    {(() => {
                      const allFiltered = getFilteredPaymentMethods();
                      const displayed = allFiltered.length > 5 ? allFiltered.slice(0, 5) : allFiltered;
                      return displayed.length > 0 ? (
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px" }}>
                          {displayed.map((pm) => (
                            <Button
                              key={pm.name}
                              size="small"
                              type={selectedPaymentMethod?.name === pm.name ? "primary" : "default"}
                              onClick={() => {
                                setSelectedPaymentMethod(pm);
                                setIsPaymentSelected(true);
                              }}
                              style={{
                                borderRadius: "7px",
                                fontSize: "12px",
                                backgroundColor: selectedPaymentMethod?.name === pm.name ? "#2F3856" : "#fff",
                                color: selectedPaymentMethod?.name === pm.name ? "#fff" : "#0F0718",
                                borderColor: "#e8e8e8",
                              }}
                            >
                              {pm.name}
                            </Button>
                          ))}
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", color: "#999", padding: "8px" }}>
                          <Spin size="small" /> Loading...
                        </div>
                      );
                    })()}
                  </div>

                  {/* Action Buttons */}
                  <div style={{ display: "flex", justifyContent: "space-between", gap: "6px" }}>
                    <Button
                      style={{ flex: 1, borderRadius: "7px", color: "#2f3856" }}
                      onClick={() => {
                        putCallOnHold({ cart, selectedStore, ahtSeconds });
                      }}
                    >
                      Park
                    </Button>
                    <Button style={{ flex: 1, borderRadius: "7px", color: "#2f3856" }}>Reorder</Button>
                    <Button
                      type="primary"
                      disabled={!isPaymentSelected}
                      style={{
                        flex: 1,
                        backgroundColor: isPaymentSelected ? "#2F3856" : "#e0e0e0",
                        borderColor: isPaymentSelected ? "#2F3856" : "#e0e0e0",
                        borderRadius: "7px",
                        position: "relative",
                        overflow: "hidden",
                      }}
                      onClick={handlePlaceOrder}
                      onMouseEnter={(e) => {
                        if (!isPaymentSelected) {
                          const btn = e.currentTarget;
                          btn.style.backgroundColor = "#ff4d4f";
                          btn.style.borderColor = "#ff4d4f";
                          btn.style.color = "#fff";
                          btn.querySelector("#place-btn-x")?.remove();
                          const x = document.createElement("span");
                          x.textContent = "X";
                          x.id = "place-btn-x";
                          x.style.position = "absolute";
                          x.style.right = "8px";
                          x.style.top = "50%";
                          x.style.transform = "translateY(-50%)";
                          x.style.fontWeight = "bold";
                          x.style.fontSize = "14px";
                          btn.appendChild(x);
                          message.error("Please select a payment method");
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isPaymentSelected) {
                          const btn = e.currentTarget;
                          btn.style.backgroundColor = "#e0e0e0";
                          btn.style.borderColor = "#e0e0e0";
                          btn.style.color = "#000";
                          btn.querySelector("#place-btn-x")?.remove();
                        }
                      }}
                    >
                      Place
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <CallCenterLandingPanel
            holdQueue={holdQueue}
            resumeHoldCall={resumeHoldCall}
            setShowCallCenterPage={setShowCallCenterPage}
            setDisplayCustomerSearch={setDisplayCustomerSearch}
            setShowProducts={setShowProducts}
            setIsCallCenterFlow={setIsCallCenterFlow}
            tillValue={tillValue}
            history={history}
          />
        )}
        {/* Store Selection Drawer */}
        <StoreSelectionDrawer
          storeModalVisible={storeModalVisible}
          setStoreModalVisible={setStoreModalVisible}
          retailStores={retailStores}
          setRetailStores={setRetailStores}
          selectedStore={selectedStore}
          setSelectedStore={setSelectedStore}
          setCart={setCart}
        />
      </div>
    </Spin>
  );
};

export default RestaurantCallCenter;
